const generateSrcset = (image, widths = []) => {
  // image["src"] from Liquid's image_url filter is protocol-relative ("//cdn.shopify.com/...").
  // Pass a base so new URL() resolves it instead of throwing; absolute URLs ignore the base.
  const imageUrl = new URL(image["src"], window.location.href);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image();
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "eager";
  newImage.style.objectFit = "contain";
  newImage.style.objectPosition = "50% 50%";
  newImage.style.width = "100%";
  newImage.style.height = "100%";
  newImage.style.position = "absolute";
  newImage.style.top = "0";
  newImage.style.left = "0";
  return newImage;
}

const productCache = new Map();

// DEV-147 perf: preload a card's variant images (from data-variant-image) on hover,
// so the bytes are cached before a swatch is clicked → the image swap is instant.
// Dedupes via a global set; only runs for cards the user actually hovers.
const preloadedVariantImages = new Set();
function preloadCardVariantImages(cardEl) {
  if (!cardEl || cardEl.dataset.variantImgsPreloaded === 'true') return;
  cardEl.dataset.variantImgsPreloaded = 'true';
  const inputs = cardEl.querySelectorAll('.js-color-swatches input[data-variant-image]');
  inputs.forEach(function (input) {
    const url = input.dataset.variantImage;
    if (!url || preloadedVariantImages.has(url)) return;
    preloadedVariantImages.add(url);
    const img = new Image();
    // low priority so it never competes with visible content
    if ('fetchPriority' in img) img.fetchPriority = 'low';
    img.decoding = 'async';
    img.src = url;
  });
}

function syncCardLinks(wrapper, variantLink) {
  if (!variantLink) return;
  var imgLink = wrapper.querySelector('.js-color-swatches-link');
  if (imgLink) imgLink.setAttribute('href', variantLink);
  var cardCta = wrapper.querySelector('.card__cta');
  if (cardCta) cardCta.setAttribute('href', variantLink);
  wrapper.querySelectorAll('.card__title .unstyled-link, .card__title .full-unstyled-link, .card-information-block > .unstyled-link').forEach(function (link) {
    link.setAttribute('href', variantLink);
  });
  var overlayLink = wrapper.querySelector('.product_card_product-link');
  if (overlayLink) overlayLink.setAttribute('href', variantLink);
  wrapper.querySelectorAll('[data-product-url]').forEach(function (btn) {
    btn.setAttribute('data-product-url', variantLink);
  });
}

function syncCardLinksFromCheckedSwatch(wrapper) {
  var checked = wrapper.querySelector('.js-color-swatches input:checked');
  if (checked && checked.dataset.variantLink) {
    syncCardLinks(wrapper, checked.dataset.variantLink);
  }
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    // Sync links on initial render from the already-checked swatch
    syncCardLinksFromCheckedSwatch(wrapper);

    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      if (input.dataset.swatchBound === 'true') return;
      input.dataset.swatchBound = 'true';
      input.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          const variantLink = event.currentTarget.dataset.variantLink;
          syncCardLinks(wrapper, variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          const performSwap = (mediaSource, productTitle) => {
            if (!mediaSource) return;
            const newPrimaryImage = createImageElement(mediaSource, primaryImage.className, primaryImage.sizes, productTitle);

            if (newPrimaryImage.src !== primaryImage.src) {
              let flag = false;
              if (secondaryImage) {
                const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                if (secondaryImagePathname == newPrimaryImagePathname) {
                  primaryImage.remove();
                  secondaryImage.classList.remove('media--second');
                  secondaryImage.classList.add('media--first');
                  flag = true;
                }
              }
              if (flag == false) {
                // DEV-147 perf: decode the new image BEFORE the crossfade so it's fully
                // ready when shown (no blank/flicker while it downloads). Tighter fade.
                const doSwap = function () {
                  primaryImage.replaceWith(newPrimaryImage);
                  newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 120, easing: "ease-out" });
                  if (secondaryImage) {
                    secondaryImage.remove();
                  }
                };
                const decodePromise = (typeof newPrimaryImage.decode === 'function')
                  ? newPrimaryImage.decode().catch(function () {})
                  : Promise.resolve();
                // Start fading the old image out while the new one decodes in parallel.
                primaryImage.animate({ opacity: [1, 0.4] }, { duration: 120, easing: "ease-out", fill: "forwards" });
                decodePromise.then(doSwap);
              }
            }
          };

          // Fast path: use inline data set by product-variant-options.liquid (no network round-trip)
          const inlineUrl = event.currentTarget.dataset.variantImage;
          const inlineWidth = parseInt(event.currentTarget.dataset.variantImageWidth, 10);
          if (inlineUrl && inlineWidth) {
            performSwap({
              alt: event.currentTarget.value,
              preview_image: { src: inlineUrl, width: inlineWidth },
            }, event.currentTarget.value);
            return;
          }

          // Fallback: fetch product JSON for cards without inline variant image data
          const swapFromProduct = (product) => {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
            if (variant) performSwap(variant.featured_media, product.title);
          };

          const cached = productCache.get(handleProduct);
          if (cached && typeof cached === 'object' && cached.variants) {
            swapFromProduct(cached);
          } else {
            // Either cache miss, or prewarm fetch still in flight (cached === 'pending')
            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
              productCache.set(handleProduct, product);
              swapFromProduct(product);
            });
          }
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

const animationCard = () => {
  document.querySelectorAll('.js-animation-card').forEach(card => {
    const buttons = card.querySelector('.card-buttons');
    if (!buttons) return;

    const heightCard = card.getBoundingClientRect().height;
    const heightButtons = buttons.scrollHeight; 
		//console.log(heightButtons)
    card.style.setProperty("--base-height", `${heightCard}px`);
    card.style.setProperty("--open-height", `${heightCard + heightButtons + 34}px`);

    card.addEventListener('mouseover', () => {
      card.classList.add('hover');
      // Preload this card's variant images on hover so swatch clicks swap instantly.
      preloadCardVariantImages(card);
    });

    card.addEventListener('mouseleave', () => {
      setTimeout(() => {
        card.classList.remove('hover');
      }, 300);
    });
  });
}

function refreshSwatchOverflow() {
  document.querySelectorAll('.product-card .js-color-swatches[data-slider-init]').forEach(function (controls) {
    var group = controls.querySelector('.product-form__controls-group');
    var prevBtn = controls.querySelector('.swatch-slider-btn--prev');
    var nextBtn = controls.querySelector('.swatch-slider-btn--next');
    if (!group || !prevBtn || !nextBtn) return;
    var hasOverflow = group.scrollWidth > group.clientWidth + 1;
    prevBtn.classList.toggle('is-visible', hasOverflow);
    nextBtn.classList.toggle('is-visible', hasOverflow);
    prevBtn.disabled = group.scrollLeft <= 0;
    nextBtn.disabled = group.scrollLeft + group.clientWidth >= group.scrollWidth - 1;
  });
}

const initSwatchSliders = () => {
  document.querySelectorAll('.product-card .js-color-swatches:not([data-slider-init])').forEach(controls => {
    controls.setAttribute('data-slider-init', '');
    const group = controls.querySelector('.product-form__controls-group');
    const prevBtn = controls.querySelector('.swatch-slider-btn--prev');
    const nextBtn = controls.querySelector('.swatch-slider-btn--next');
    if (!group || !prevBtn || !nextBtn) return;

    // Get visible swatch labels in VISUAL order, sorted by painted left position.
    // Excludes absolutely-positioned <input> siblings; respects style="order:" reordering.
    const getItems = () => {
      const labels = Array.from(group.querySelectorAll('label.variant-swatch-label, label.color-swatch'));
      const groupRect = group.getBoundingClientRect();
      const groupLeft = groupRect.left;
      const sl = group.scrollLeft;
      const items = labels.map(el => {
        const rect = el.getBoundingClientRect();
        return { el, left: (rect.left - groupLeft) + sl, width: rect.width };
      });
      items.sort((a, b) => a.left - b.left);
      return items;
    };

    // Read the actual gap between items inside the SCROLL CONTAINER (not the outer wrapper).
    const getGroupGap = () => {
      const styles = window.getComputedStyle(group);
      return parseFloat(styles.columnGap || styles.gap || '0') || 0;
    };

    // Read the gap of the OUTER wrapper (.js-color-swatches) — separate from group gap.
    const getControlsGap = () => {
      const styles = window.getComputedStyle(controls);
      return parseFloat(styles.columnGap || styles.gap || '0') || 0;
    };

    // Single source of truth: compute layout metrics, apply max-width, return shared values.
    // Resets max-width before measuring to avoid feedback loop.
    const computeMetrics = () => {
      // STEP 1: fully reset any previously-applied width override before measurement
      group.style.maxWidth = '';

      const items = getItems();
      if (items.length === 0) {
        return { items, slotWidth: 0, gap: 0, N: 0, targetWidth: 0, maxLeading: 0 };
      }

      // STEP 2: measure slot geometry from the actual first label
      const slotItemWidth = items[0].width || 40;
      const gap = getGroupGap();
      const slotWidth = slotItemWidth + gap;

      // STEP 3: compute available space inside the outer wrapper for the scroll container
      // available = controls.clientWidth - prevBtn.offsetWidth - nextBtn.offsetWidth - (2 * outer gap)
      const prevW = prevBtn.offsetWidth || 0;
      const nextW = nextBtn.offsetWidth || 0;
      const outerGap = getControlsGap();
      const available = controls.clientWidth - prevW - nextW - (outerGap * 2);

      // STEP 4: how many whole slots fit? N = floor((available + gap) / slotWidth)
      // Subtract trailing gap from each slot count: total width for N items = N * slotWidth - gap
      let N = Math.max(1, Math.floor((available + gap) / slotWidth));
      // Don't claim more slots than items exist
      if (N > items.length) N = items.length;
      const targetWidth = Math.max(slotItemWidth, N * slotWidth - gap);

      // STEP 5: apply max-width — browser may produce a clientWidth slightly off due to
      // box-sizing, borders, scrollbar, sub-pixel rounding. We don't assume exact equality.
      group.style.maxWidth = targetWidth + 'px';

      // STEP 6: compute the maximum valid leading index (clamp for arrow logic)
      // visibleCount = N (items that fit in target viewport)
      // maxLeading = items.length - N → at this scroll position, the LAST visible item is items[items.length - 1] (the very last swatch)
      const maxLeading = Math.max(0, items.length - N);

      return { items, slotWidth, gap, N, targetWidth, maxLeading };
    };

    // Find the leading visible index — the leftmost item whose left edge is at/after scrollLeft
    const getLeadingIndex = (items) => {
      const sl = group.scrollLeft;
      for (let i = 0; i < items.length; i++) {
        if (items[i].left >= sl - 0.5) return i;
      }
      return Math.max(0, items.length - 1);
    };

    const updateButtons = () => {
      // Tolerance: 1px for sub-pixel rounding differences
      const hasOverflow = group.scrollWidth > group.clientWidth + 1;
      prevBtn.classList.toggle('is-visible', hasOverflow);
      nextBtn.classList.toggle('is-visible', hasOverflow);
      prevBtn.disabled = group.scrollLeft <= 0.5;
      nextBtn.disabled = group.scrollLeft + group.clientWidth >= group.scrollWidth - 1;
    };

    // Arrow click: scroll by N whole items, clamped to [0, maxLeading].
    // Uses the same metrics as computeMetrics() to avoid drift between layout and click logic.
    const scrollByItems = (direction) => {
      const metrics = computeMetrics();
      if (metrics.items.length === 0 || metrics.N === 0) return;
      const { items, N, maxLeading } = metrics;
      const leadingIdx = getLeadingIndex(items);
      const targetIdx = Math.max(0, Math.min(maxLeading, leadingIdx + direction * N));
      group.scrollTo({ left: items[targetIdx].left, behavior: 'smooth' });
    };

    prevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      scrollByItems(-1);
    });
    nextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      scrollByItems(1);
    });

    // Scroll listener: only updates arrow disabled state. CSS scroll-snap handles snapping.
    group.addEventListener('scroll', updateButtons, { passive: true });

    // DEV-122: scroll the slider so the CHECKED swatch is visible. When a color
    // filter pre-selects a variant, its swatch may be reordered/scrolled out of the
    // visible window — this brings it into view so the active swatch is seen.
    const scrollActiveIntoView = (smooth) => {
      const metrics = computeMetrics();
      if (!metrics.items.length || !metrics.maxLeading) return; // no overflow, nothing to do
      const checkedInput = group.querySelector('input[type="radio"]:checked');
      if (!checkedInput) return;
      const activeLabel = group.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(checkedInput.id) : checkedInput.id) + '"]');
      if (!activeLabel) return;
      const idx = metrics.items.findIndex((it) => it.el === activeLabel);
      if (idx < 0) return;
      const targetIdx = Math.min(metrics.maxLeading, idx);
      group.scrollTo({ left: metrics.items[targetIdx].left, behavior: smooth ? 'smooth' : 'auto' });
    };

    // Initial layout: compute metrics + update buttons after first paint
    requestAnimationFrame(() => {
      computeMetrics();
      scrollActiveIntoView(false);
      updateButtons();
    });

    // One deferred re-fit after window.load — catches lazy-loaded swatch images that
    // may have caused a reflow after the initial requestAnimationFrame ran
    const deferredRefit = () => {
      computeMetrics();
      scrollActiveIntoView(false);
      updateButtons();
    };
    if (document.readyState === 'complete') {
      // Already loaded — defer one tick so any pending layout work settles first
      requestAnimationFrame(deferredRefit);
    } else {
      window.addEventListener('load', deferredRefit, { once: true });
    }

    // Re-fit on parent resize (window resize, orientation change, parent layout shift)
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => {
        computeMetrics();
        updateButtons();
      });
      ro.observe(controls);
    }

    // Prevent card hover when mouse is on the swatch slider
    controls.addEventListener('mouseover', (e) => {
      e.stopPropagation();
      const card = controls.closest('.js-animation-card');
      if (card) card.classList.remove('hover');
    });
    controls.addEventListener('mouseleave', () => {
      const card = controls.closest('.js-animation-card');
      if (card && card.matches(':hover')) {
        card.classList.add('hover');
      }
    });
  });
};

window.addEventListener('load', () => {
  animationCard();
  initSwatchSliders();
});


(function () {
  colorSwatches();
  animationCard();
  initSwatchSliders();
  document.addEventListener('shopify:section:load', function () {
    animationCard();
    initSwatchSliders();
  });
		let resizeTimeout;
			window.addEventListener('resize', function () {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(animationCard, 100);
				resizeTimeout = setTimeout(initSwatchSliders, 100);
			});
})()

// Pre-warm product JSON cache for swatch wrappers without inline variant data,
// so the first swatch click never waits on a network round-trip.
const prewarmSwatchCache = (root) => {
  if (!root || !window.jQuery) return;
  const scope = root === document ? root : root;
  scope.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    const handle = wrapper.dataset.product;
    if (!handle || productCache.has(handle)) return;
    // Skip if every swatch already has inline data — fast path will handle it
    const inputs = wrapper.querySelectorAll('.js-color-swatches input');
    if (inputs.length > 0) {
      const allInline = Array.from(inputs).every(i => i.dataset.variantImage && i.dataset.variantImageWidth);
      if (allInline) return;
    }
    productCache.set(handle, 'pending'); // claim slot to dedupe concurrent prewarm
    jQuery.getJSON(window.Shopify.routes.root + `products/${handle}.js`, function(product) {
      productCache.set(handle, product);
    }).fail(() => productCache.delete(handle));
  });
};

// Re-init swatch functionality when product-recommendations loads AJAX content
const recoEl = document.querySelector('product-recommendations');
if (recoEl) {
  let recoTimer;
  new MutationObserver(() => {
    clearTimeout(recoTimer);
    recoTimer = setTimeout(() => {
      checkSwatches();
      initSwatchSliders();
      animationCard();
      prewarmSwatchCache(recoEl);
      // Re-check overflow after Swiper finishes initializing and sets final slide widths
      setTimeout(refreshSwatchOverflow, 500);
    }, 150);
  }).observe(recoEl, { childList: true, subtree: true });
}

// DEV-122: re-init cards after the collection/search facet AJAX swaps the grid.
// Search & Discovery's facets.js replaces #ProductGridContainer innerHTML without
// dispatching shopify:section:load, so hover-button heights (animationCard) and
// swatch slider arrows (initSwatchSliders) were never re-computed on the new cards.
const gridEl = document.getElementById('ProductGridContainer');
if (gridEl) {
  let gridTimer;
  new MutationObserver(() => {
    clearTimeout(gridTimer);
    gridTimer = setTimeout(() => {
      if (typeof checkSwatches === 'function') { checkSwatches(); }
      initSwatchSliders();
      animationCard();
      if (typeof prewarmSwatchCache === 'function') { prewarmSwatchCache(gridEl); }
      setTimeout(refreshSwatchOverflow, 300);
    }, 150);
  }).observe(gridEl, { childList: true, subtree: true });
}